import axios, { AxiosResponse } from 'axios';
import endpoints from 'services/endpoints';
import { Merchant } from 'types/types';

export const getMerchants = (): Promise<AxiosResponse<Merchant[]>> => {
  return axios.get(endpoints.entities.MERCHANTS);
};
